// src/utils/constants.js

// ─── Défauts physiques ────────────────────────────────────────────────────────
export const DEFAUTS_PHYSIQUES = {
  couverture: {
    label: 'Couverture',
    icon: '📕',
    items: [
      'Annotations au crayon',
      'Annotations au stylo',
      'Autocollant / étiquette prix',
      'Coins cornés / pliés',
      'Couverture désolidarisée / décollée',
      'Couverture fanée / décolorée',
      'Couverture gondolée',
      'Déchirure',
      'Griffe / griffure profonde',
      'Marque de tampon',
      'Pli permanent',
      'Rayures',
      'Taches diverses',
      'Taches d\'humidité / auréoles',
    ],
  },
  dos: {
    label: 'Dos / Reliure',
    icon: '📗',
    items: [
      'Coup sur le dos',
      'Dos cassé / fissuré',
      'Dos complètement fendu',
      'Dos fendu partiellement',
      'Dos jauni / marqué',
      'Dos plié / écrasé',
      'Pages se détachent',
      'Reliure décollée',
    ],
  },
  pages: {
    label: 'Pages intérieures',
    icon: '📄',
    items: [
      'Annotations au crayon',
      'Annotations au stylo',
      'Auréoles d\'humidité',
      'Foxing (taches de rousseur)',
      'Jaunissement',
      'Moisissures',
      'Odeur forte (humidité)',
      'Odeur forte (tabac)',
      'Pages collées',
      'Pages cornées',
      'Pages déchirées',
      'Pages gondolées / ondulées',
      'Pages manquantes',
      'Soulignements / surlignages',
      'Taches (café / thé)',
      'Taches (eau)',
      'Taches (encre)',
      'Taches (nourriture)',
    ],
  },
  tranche: {
    label: 'Tranche',
    icon: '📐',
    items: [
      'Tranche avec tampon',
      'Tranche jaunie',
      'Tranche marquée / salie',
      'Tranche usée',
    ],
  },
  extras: {
    label: 'Jaquette & extras',
    icon: '🎁',
    items: [
      'Dédicace non souhaitée',
      'Ex-libris collé',
      'Jaquette absente',
      'Jaquette abîmée / déchirée',
      'Jaquette fanée',
      'Poster / supplément manquant',
    ],
  },
};

// ─── Genres ───────────────────────────────────────────────────────────────────
export const GENRES = [
  'Action / Aventure',
  'Anticipation / Dystopie',
  'Aventure historique',
  'Biographie / Mémoires',
  'Comic book américain',
  'Documentaire / Reportage',
  'Érotique (adulte)',
  'Espionnage / Thriller',
  'Fantastique / Fantasy',
  'Guerre',
  'Histoire / Péplum',
  'Horreur / Gore',
  'Humour / Gags',
  'Humour noir / Satire',
  'Jeunesse',
  'Manga – Josei',
  'Manga – Kodomomuke',
  'Manga – Seinen',
  'Manga – Shōjo',
  'Manga – Shōnen',
  'Policier / Noir',
  'Politique / Social',
  'Poésie / Expérimental',
  'Roman graphique',
  'Science-fiction',
  'Super-héros',
  'Terroir / Régional',
  'Western',
  'Autre',
];

// ─── Éditeurs (complet, trié alphabétiquement) ────────────────────────────────
// Couvre : Astérix (Hachette/Albert René/Dargaud), Lucky Luke (Dargaud/Lucky Comics/Dupuis),
// Schtroumpfs (Dupuis/Le Lombard), Marsupilami (Dupuis/Marsu Productions),
// Tintin (Casterman/Moulinsart), Naruto (Kana), Dragon Ball (Glénat/Éditions Pastel),
// One Piece (Glénat), mangas en général, + grande BD franco-belge
export const EDITEURS = [
  '12 bis',
  'Akata',
  'Albert René',
  'Ankama',
  'Arboris',
  'Bamboo',
  'Casterman',
  'Citel',
  'Dargaud',
  'Delcourt',
  'Drugstore',
  'Dupuis',
  'Éditions Pastel',
  'Emmanuel Proust',
  'Fluide Glacial',
  'Futuropolis',
  'Glénat',
  'Hachette',
  'Hachette Comics',
  'Hachette Livre',
  'Jungle',
  'Kana',
  'Ki-oon',
  'Kurokawa',
  'Le Lombard',
  'Les Humanoïdes Associés',
  'Lucky Comics',
  'Marabout',
  'Marsu Productions',
  'Michel Lafon',
  'Milan',
  'Moulinsart',
  'Panini Comics',
  'Pika Édition',
  'Rue de Sèvres',
  'Sarbacane',
  'Soleil',
  'Urban Comics',
  'Vents d\'Ouest',
  'Autre',
].sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));

// ─── États généraux ───────────────────────────────────────────────────────────
export const ETATS_GENERAUX = [
  { value: 'neuf',       label: 'Neuf',          color: '#16A34A' },
  { value: 'tres_bon',   label: 'Très bon état',  color: '#65A30D' },
  { value: 'bon',        label: 'Bon état',       color: '#CA8A04' },
  { value: 'acceptable', label: 'Acceptable',     color: '#EA580C' },
  { value: 'mauvais',    label: 'Mauvais état',   color: '#DC2626' },
];

// ─── Statuts ──────────────────────────────────────────────────────────────────
export const STATUTS = [
  { value: 'garder',    label: 'À garder',        emoji: '💚', color: '#16A34A' },
  { value: 'vendre',    label: 'À vendre',         emoji: '🏷️', color: '#DC2626' },
  { value: 'attente',   label: 'En attente',       emoji: '⏳', color: '#D97706',
    desc: 'Gardé temporairement — en attente de trouver la version cible' },
  { value: 'remplacer', label: 'À remplacer',      emoji: '🔁', color: '#EA580C',
    desc: 'À remplacer par un meilleur exemplaire (meilleur état ou autre édition)' },
  { value: 'echanger',  label: 'À échanger',       emoji: '🔄', color: '#2563EB' },
  { value: 'pret',      label: 'En prêt',          emoji: '📤', color: '#7C3AED' },
  { value: 'recherche', label: 'Recherché',         emoji: '🔍', color: '#0D9488' },
  { value: 'hesiter',   label: 'Indécis',           emoji: '🤔', color: '#8A7E72' },
];

// ─── Langues ──────────────────────────────────────────────────────────────────
export const LANGUES = [
  'Allemand', 'Anglais', 'Arabe', 'Chinois', 'Espagnol',
  'Français', 'Italien', 'Japonais', 'Néerlandais', 'Portugais', 'Autre',
].sort((a, b) => a.localeCompare(b, 'fr'));

// ─── Formats ──────────────────────────────────────────────────────────────────
export const FORMATS = [
  'Album standard',
  'Album grand format',
  'Album petit format',
  'Coffret',
  'Hors-série',
  'Intégrale',
  'Intégrale numérotée',
  'Manga poche',
  'Manga grand format',
  'Numéro de magazine',
  'One-shot',
  'Édition prestige',
  'Édition collector',
  'Édition limitée / numérotée',
  'Édition spéciale',
  'Autre',
];

// ─── Lieux d'achat ────────────────────────────────────────────────────────────
export const LIEUX_ACHAT = [
  "Amazon",
  "Bouquinerie / Librairie d'occasion",
  "Brocante",
  "Cash Converters",
  "Collector's shop",
  "Don / Cadeau",
  "eBay",
  "Emmaüs",
  "Fnac",
  "Foire du livre",
  "Grande surface",
  "Label Emmaüs",
  "Le Bon Coin",
  "Librairie indépendante",
  "Momox",
  "Rakuten",
  "Récupération (famille, ami)",
  "Salon du livre / Festival BD",
  "Vinted",
  "Vide-grenier / Brocante",
  "Autre",
].sort((a, b) => a.localeCompare(b, "fr", { sensitivity: "base" }));

// ─── Séries populaires pour autocomplétion ────────────────────────────────────
export const SERIES_POPULAIRES = [
  // BD franco-belge
  "Astérix", "Tintin", "Lucky Luke", "Les Schtroumpfs", "Marsupilami",
  "Spirou et Fantasio", "Gaston Lagaffe", "Blake et Mortimer", "Thorgal",
  "Largo Winch", "XIII", "Blacksad", "Corto Maltese", "Blueberry",
  "Les Tuniques Bleues", "Iznogoud", "Léonard", "Les Bidochon",
  "Titeuf", "Boule et Bill", "Cédric", "Achille Talon",
  "Les Femmes en Blanc", "Ric Hochet", "Bob et Bobette",
  "Cubitus", "Kappel", "Docteur Justice",
  // Manga
  "Naruto", "One Piece", "Dragon Ball", "Bleach", "Death Note",
  "Fullmetal Alchemist", "Attack on Titan", "Demon Slayer", "My Hero Academia",
  "Hunter x Hunter", "One Punch Man", "Fairy Tail", "Sword Art Online",
  "Tokyo Ghoul", "Vinland Saga", "Berserk", "Vagabond", "Monster",
  "20th Century Boys", "Akira", "Ghost in the Shell",
  "Ranma ½", "Dragon Ball Z", "Saint Seiya", "Sailor Moon",
  "Neon Genesis Evangelion", "Jojo's Bizarre Adventure",
  // Comics
  "Spider-Man", "Batman", "Superman", "X-Men", "Avengers",
  "Watchmen", "V pour Vendetta", "Sandman",
  // Romans graphiques / autres
  "Persepolis", "Maus", "La Guerre Éternelle",
].sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
